import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { EGetFavoritesListActionTypes, TGetFavoritesListLoading } from './types';

export const getFavoritesListLoading: () => TGetFavoritesListLoading =
  actionGenerator<EGetFavoritesListActionTypes.Loading>(EGetFavoritesListActionTypes.Loading);
